<template>
  <div class="gamedetailsRapper">
    <header class="header1" v-show="!showAbs" :style="opacityStyle">
      <div>
        <img v-lazy="require('@/assets/images/game/return.png')" alt @click="returnpage" />
      </div>
      <span>游戏详情</span>
      <div></div>
    </header>
    <div class="content" :class="{paddingStyle:noVideo}" v-if="!!gameInfo">
      <div class="videoCon" v-if="videoImg">
        <video :src="videoUrl" autoplay="autoplay" controls muted :poster="videoImg">您的设备不支持播放视频</video>
        <header class="header2">
          <div>
            <img v-lazy="require('@/assets/images/game/videoReturn.png')" alt @click="returnpage" />
          </div>
          <span></span>
          <!-- <div><img src="~assets/images/game/share.png" alt=""></div> -->
        </header>
      </div>
      <div class="details">
        <div class="imgCon">
          <img v-lazy="gameInfo.iconUrl" :key="gameInfo.iconUrl" alt />
        </div>
        <div class="gameInfo">
          <p class="title">{{gameInfo.displayName ? gameInfo.displayName : gameInfo.appName }}</p>
          <div class="descript">
            <div class="size">
              <p>{{gameInfo.appDownCount|handleDownload}}下载&nbsp;&nbsp;{{gameInfo.fileSize|handlePkgSize}}</p>
              <div class="score">
                <img v-lazy="require('@/assets/images/game/star.png')" alt />
                {{rating ? rating : score}}
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- <div class="tab">
				<router-link tag="div" to="/game/gamedetails/briefintro" class="brief" active-class="tabActive" replace>简介<span class="line"></span></router-link>
				<router-link tag="div" to="/game/gamedetails/comment" class="comment" active-class="tabActive" replace>评论<span class="line"></span><span class="number">4633+</span></router-link>
      </div>-->
      <router-view :gameInfo="gameInfo" :gameId="gameId" :packName="packName"></router-view>
    </div>
    <div class="downloadCon" @click="todownload">
      <div class="bg" :style="originwid != '100%'?'background:#FFE4DB':''">
        <div class="left" :style="{width:originwid}">
          <div class="l-text l-w-text">{{bottombtntext}}</div>
        </div>
        <div class="r-text r-w-text">{{bottombtntext}}</div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState, mapMutations } from "vuex";
import { androidMethod, goBack } from "@/utils/base";
export default {
  data() {
    return {
      videoUrl: "", //video url
      videoImg: "", //video img
      isHeaderShow: false,
      displayLine: true, //选中简介还是评论
      gameInfo: null,
      gameId: "",
      showAbs: true, //true默认没有video时不显示header
      noVideo: true, //true默认没有video时显示padding-top
      opacityStyle: {
        opacity: 0
      },
      btnstate: 0, //0 下载, 1.进行中, 2.暂停, 3.打开
      // btntext: "下载", //上面按钮的文字展示
      bottombtntext: "开始游戏", //下面按钮的文本展示
      packName: "", //包名
      originwid: "100%",
      progress: "0",
      clickBtn: true, //防止多次点击 1s
      timer: null
    };
  },
  computed: {
    ...mapState({
      score: state => state.game.score,
      rating: state => state.game.rating
    })
  },
  created() {
    let that = this;
    this.gameId = this.$route.query.gameId || 1;
    let cdnUrl = this.$route.query.cdnUrl;
    if (cdnUrl) {
      this.$http.get(`${cdnUrl}`).then(res => {
        if (res.status == 200) {
          this.gameInfo = res.data;
          this.gameId = res.data.id;
          this["game/setRating"](res.data.rating);
          this.cdnAndInterface();
        } else {
          this.$nextTick().then(() => {
            collect("event_gametails_basic_show", {
              gameid: this.gameId,
              status: 0
            });
          });
        }
      });
    } else {
      // /apiserv/api/repository/game/getGameById?id=${this.gameId}
      // this.$http.get(`http://easymock.233wei.cn/mock/5e3bda997967af073af3f910/repository/game/getGameById?id=1#!method=get`).then(res => {
      this.$http
        .get(`/apiserv/api/repository/game/getGameById?id=${this.gameId}`)
        .then(res => {
          if (res.data.return_code == 200) {
            this.gameInfo = res.data.data.detail;
            this["game/setRating"](this.gameInfo.rating);
            this.cdnAndInterface();
          } else {
            this.$nextTick().then(() => {
              collect("event_gametails_basic_show", {
                gameid: this.gameId,
                status: 0
              });
            });
          }
        });
    }
  },
  filters: {
    handleDownload: function(value) {
      if (value >= 10000) {
        return Math.ceil(value / 10000) + "万+";
      }
      return value + "次";
    },
    handlePkgSize: function(value) {
      let a = Math.floor((value / 1048576) * 100) / 100;
      if (a > 1024) {
        return Math.floor((a / 1024) * 100) / 100 + "G";
      } else {
        return a + "M";
      }
    }
  },
  methods: {
    ...mapMutations(["game/setRating"]),
    cdnAndInterface() {
      let that = this;
      this.packName = this.gameInfo.packageName;

      this.$nextTick().then(() => {
        collect("event_gametails_basic_show", {
          gameid: this.gameId,
          packagename: this.packName,
          status: 1
        });
      });

      if (androidMethod("isGameInstall", "", this.packName) != "false") {
        this.btnstate = 3;
        // this.btntext = '打开'
        this.bottombtntext = "开始游戏";
      } else {
        this.btnstate = localStorage.getItem("status")
          ? localStorage.getItem("status")
          : 0;
        if (this.btnstate == 2) {
          // this.btntext = "继续";
          this.bottombtntext = "继续";
        } else {
          // this.btntext = "下载";
          this.bottombtntext = "开始游戏";
          this.btnstate = 0;
        }
      }

      if (!that.gameInfo.videos || that.gameInfo.videos.length == 0) {
        this.showAbs = false;
        this.opacityStyle = {
          opacity: 1
        };
        this.noVideo = true;
      } else {
        this.noVideo = false;
        this.videoImg = that.gameInfo.videos[0].videoImageUrl;
        setTimeout(function() {
          that.videoUrl = that.gameInfo.videos[0].videoUrl;
        }, 200);
      }
    },
    returnpage() {
      goBack();
    },
    switchLine(dir) {
      if (dir == "left") {
        this.displayLine = true;
      } else {
        this.displayLine = false;
      }
    },
    todownload() {
      if (!this.clickBtn) {
        return false;
      }
      this.clickBtn = false;
      if (!this.timer) {
        this.timer = setTimeout(() => {
          this.clickBtn = true;
          this.timer = null;
        }, 1000);
      }
      if (this.btnstate == 0 || this.btnstate == 2) {
        collect("event_gametails_click_download", {
          gameid: this.gameId,
          packagename: this.packName,
          status: 1
        });
        androidMethod(
          "downloadGame",
          "",
          this.progress,
          JSON.stringify(this.gameInfo)
        );
      } else if (this.btnstate == 1) {
        collect("event_gametails_click_pause", {
          gameid: this.gameId,
          packagename: this.packName
        });
        androidMethod("downloadStop", "", JSON.stringify(this.gameInfo));
      } else {
        collect("event_gametails_open_game", {
          gameid: this.gameId,
          packagename: this.packName,
          type: 1
        });
        androidMethod("playGame", "", JSON.stringify(this.gameInfo));
      }
    },
    handleScroll() {
      if (this.gameInfo.videos && this.gameInfo.videos.length > 0) {
        const top = document.documentElement.scrollTop;
        if (top > 77) {
          let opacity = top / 140;
          opacity = opacity > 1 ? 1 : opacity;
          this.opacityStyle = { opacity };
          this.showAbs = false;
        } else {
          this.showAbs = true;
        }
      }
    }
  },
  mounted() {
    //下载的状态；0下载；1进行中；2暂停；3打开
    //进入页面就会调用的方法
    window["AndroidLifeOnResume"] = () => {
      if (androidMethod("isGameInstall", "", this.packName)) {
        this.btnstate = 3;
        // this.btntext = '打开'
        this.bottombtntext = "开始游戏";
      } else {
        this.btnstate = localStorage.getItem("status")
          ? localStorage.getItem("status")
          : 0;
        if (this.btnstate == 2) {
          // this.btntext = "继续";
          this.bottombtntext = "继续";
        } else {
          // this.btntext = "下载";
          this.bottombtntext = "开始游戏";
          this.btnstate = 0;
        }
      }
    };
    //下载失败
    window["DownloadFailed"] = pkg => {
      if (pkg == this.packName) {
        // this.btntext = "下载";
        this.bottombtntext = "开始游戏";
        this.btnstate = 0;
      }
    };
    //下载成功
    window["DownloadSuccess"] = pkg => {
      if (pkg == this.packName) {
        collect("event_gametails_finish_download", {
          gameid: this.gameId,
          packagename: this.packName
        });
        this.btnstate = 3;
        // this.btntext = '打开';
        this.bottombtntext = "开始游戏";
        collect("event_gametails_open_game", {
          gameid: this.gameId,
          packagename: this.packName,
          type: 1
        });
        androidMethod("playGame", "", JSON.stringify(this.gameInfo));
      }
    };
    //下载暂停
    window["DownloadInterrupt"] = pkg => {
      if (pkg == this.packName) {
        this.btnstate = 2;
        // this.btntext = '继续';
        this.bottombtntext = "继续";
      }
    };
    //下载进度的回调
    window["DownloadProgress"] = (pkg, progress) => {
      //包名，游戏id,状态 pkg, gid, progress
      this.progress = progress;
      if (pkg == this.packName) {
        var num = progress * 100;
        if (num <= 33) {
          this.bottombtntext = "界面加载中" + num.toFixed(2) + "%";
        } else if (num > 33 && num <= 66) {
          this.bottombtntext = "资源加载中" + num.toFixed(2) + "%";
        } else {
          this.bottombtntext = "数据解析中" + num.toFixed(2) + "%";
        }
        this.btnstate = 1;
        this.originwid = num.toFixed(2) + "%";
      }
    };
    window.addEventListener("scroll", this.handleScroll);
  },
  beforeDestroy() {
    this.timer = null;
    window.removeEventListener("scroll", this.handleScroll);
  }
};
</script>

<style lang='less' scoped>
.gamedetailsRapper {
  background: #e6e6e6;
  header {
    height: 0.5rem;
    display: flex;
    padding: 0.166rem;
    > :nth-child(1) {
      flex: 1;
      display: flex;
      align-items: center;
      img {
        width: 0.25rem;
        height: 0.25rem;
        margin-left: -0.05rem;
      }
    }
    > :nth-child(2) {
      flex: 3;
      text-align: center;
      line-height: 0.168rem;
      font-size: 0.19rem;
      font-weight: 400;
      color: rgba(27, 27, 27, 1);
    }
    > :nth-child(3) {
      flex: 1;
    }
  }
  .header1 {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    background: #fff;
    z-index: 999;
  }
  .paddingStyle {
    padding-top: 0.5rem;
  }
  .content {
    .videoCon {
      position: relative;
      video {
        width: 3.75rem;
        animation: myheight 0.5s;
        height: 1.79rem;
      }
      @keyframes myheight {
        0% {
          height: 0;
          opacity: 0.2;
        }
        25% {
          height: 0.5rem;
          opacity: 0.4;
        }
        50% {
          height: 1rem;
          opacity: 0.6;
        }
        75% {
          height: 1.5rem;
          opacity: 0.8;
        }
        100% {
          height: 1.79rem;
          opacity: 1;
        }
      }
      .header2 {
        position: absolute;
        width: 100%;
        height: 0.52rem;
        top: 0.25rem;
        left: 0;
        img {
          width: 0.33rem;
          height: 0.33rem;
        }
        > :nth-child(1) {
          flex: 1;
          display: flex;
          align-items: center;
        }
        > :nth-child(3) {
          flex: 1;
          display: flex;
          justify-content: flex-end;
          align-items: center;
        }
      }
    }
    .details {
      display: flex;
      padding: 0.17rem;
      background: #fff;
      .imgCon {
        width: 0.83rem;
        height: 0.83rem;
        img {
          width: 100%;
          border-radius: 0.17rem;
        }
      }
      > img {
        width: 0.83rem;
        height: 0.83rem;
        border-radius: 0.17rem;
      }
      .gameInfo {
        width: 3rem;
        margin-left: 0.12rem;
        .title {
          font-size: 0.19rem;
          font-weight: 500;
          color: rgba(28, 28, 28, 1);
          line-height: 0.19rem;
          font-family: PingFangSC-Medium, PingFang SC;
        }
        .descript {
          display: flex;
          justify-content: space-between;
          margin-top: 0.12rem;
          .size {
            > p {
              font-size: 0.14rem;
              line-height: 0.19rem;
              font-weight: 400;
              color: #999999;
            }
            .score {
              display: flex;
              justify-content: flex-start;
              align-items: center;
              height: 0.17rem;
              line-height: 0.17rem;
              font-size: 0.18rem;
              color: #ff9500;
              font-weight: 600;
              margin-top: 0.04rem;
              img {
                width: 0.17rem;
                height: 0.17rem;
                margin-right: 0.04rem;
              }
            }
          }
        }
      }
    }
    .tab {
      position: sticky;
      top: 0.5rem;
      left: 0;
      height: 0.42rem;
      background: #fff;
      z-index: 9999;
      display: flex;
      align-items: center;
      justify-content: center;
      > div {
        width: 50%;
        height: 0.42rem;
        line-height: 0.42rem;
        float: left;
        text-align: center;
        font-size: 0.15rem;
        color: #1c1c1c;
        position: relative;
        .line {
          position: absolute;
          bottom: 0;
          left: 50%;
          margin-left: -0.05rem;
          width: 0.1rem;
          height: 0.03rem;
          background: transparent;
          border-radius: 0.02rem;
        }
      }
      .comment {
        position: relative;
        .number {
          position: absolute;
          top: 0rem;
          left: 1.15rem;
          font-size: 0.11rem;
          color: #999999;
          margin-left: 0.01rem;
        }
      }
      .tabActive {
        font-size: 0.18rem;
        font-weight: 600;
        color: #1c1c1c;
        .line {
          background: rgba(255, 80, 0, 1);
        }
      }
    }
  }
  .downloadCon {
    width: 100%;
    position: fixed;
    bottom: 0;
    left: 0;
    height: 0.54rem;
    background: #fff;
    box-shadow: 0px -0.1rem 0.33rem 0.1rem rgba(255, 255, 255, 1);
    padding: 0 0.17rem 0.08rem;
    .bg {
      background: #fff;
      border-radius: 22px;
      border: 1px solid #ff5000;
      width: 3.42rem;
      height: 0.46rem;
      line-height: 0.46rem;
      position: relative;
      overflow: hidden;
      display: flex;
    }

    .left {
      height: 100%;
      background-color: #ff5000;
      overflow: hidden;
      position: absolute;
      left: 0;
      z-index: 2;
    }

    .l-text,
    .r-text {
      width: 3.42rem;
      height: 100%;
      text-align: center;
      font-size: 0.19rem;
      font-weight: 500;
    }

    .l-w-text {
      color: #fff !important;
    }

    .r-w-text {
      position: absolute;
      color: #ff5000;
      z-index: 1;
    }
  }
}
</style>